import { render, staticRenderFns } from "./WebTabCreated.vue?vue&type=template&id=53ff776c"
import script from "./WebTabCreated.vue?vue&type=script&lang=js"
export * from "./WebTabCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports